import type { LocationQuery } from 'vue-router';
import type { NitroFetchRequest } from 'nitropack';
import type { FetchOptions } from 'ofetch';
type UrlType = string | Request | Ref<string | Request> | (() => string | Request);
import pinia from '@/store/store';
import { store } from '@/store/index';
import { storeToRefs } from 'pinia';
import { message } from 'ant-design-vue';
import { httpBaseUrl } from './variable';
import myStorage from '@/utils/storage';
interface Params {
  url: NitroFetchRequest;
  opts: FetchOptions<any>;
  method?: 'get' | 'post';
}
// 接口传参要求
interface QueryItem {
  uid?: string;
  token?: LocationQuery;
}
export interface RequestOptions {
  method?: any;
  params?: any;
}
const piniaStore = store(pinia);
// 创建axios实例
const request = async (url: UrlType, params: any, options: RequestOptions) => {
  const headers = useRequestHeaders(['cookie']);
  const route = useRoute();
  const { apiBase: baseURL } = useRuntimeConfig().public;
  const { method = ((options?.method || 'GET') as string).toUpperCase() } = options;
  // const query: QueryItem = route.query;
  const runtimeConfig = useRuntimeConfig();
  let cid = runtimeConfig.public.nuxtChannelId;
  await nextTick();
  return await useFetch(url as string, {
    default: () => [],
    baseURL,
    method,
    params: { ...params },//temp hook
    timeout: 2000000,
    headers,
    key: new Date().getMilliseconds().toString(),
    lazy: false,
    credentials: 'include',
    body: method === 'POST' ? JSON.stringify(params) : undefined,
    onRequest({ request, options }) {
      // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
      // const token = piniaStore.getToken;
      const lang = piniaStore.getLang.toLowerCase();
      options.headers = { ...options.headers, Authorization: myStorage.getStore('token'), Cid: cid as string, Language: lang };
      if (method === 'post' || method === 'put') {
        options.body = { ...params };
        // options.query = query;
      } else {
        options.query = { ...params };
      }
      // Set the request headers
      //   options.headers = options.headers || {};
    },
    onRequestError({ request, options, error }) {

      // Handle the request errors
    },
    onResponse({ request, response, options }) {
      // Process the response data
      piniaStore.setSpin(false);
      // if (response._data.status == -1) {
      //   myStorage.delStore('token');
      //   myStorage.delStore('userInfo');
      //   piniaStore.setIsLogin(false);
      // }
      return response._data;
    },
    onResponseError({ request, response, options }) {
      // Handle the response errors
    },
  });
};

// 添加请求拦截器
// onRequest(
//   (request, config) => {

//     // 在发送请求之前做些什么
//     // 统一加密认证参数
//     // config.params.timestamp = moment().format('YYYYMMDDHHmmss')

//     // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
//     const token = piniaStore.getToken;
//     token && (config.headers['Authorization'] = token);
//     // config.headers['Cid'] = channelCid;
//     config.headers['Language'] = piniaStore.getLang.toLowerCase();
//     if (config.url !== '/content-url/rest/airport/search') {
//       piniaStore.setSpin(true);
//     }
//     //若请求方式为post，则将data参数转为JSON字符串
//     // if (config.method === 'patch') {
//     //     // config.data = JSON.stringify(config.data);
//     // config.data = Qs.stringify(config.data);
//     // }
//     return config;
//   },
//   (error) => {
//     // 对请求错误做些什么
//     return Promise.reject(error);
//   }
// );

// 添加响应拦截器
// $http.interceptors.response.use(
//   (response) => {
//     // 对响应数据做点什么
//     if (response.config.url === '/order-url/PolarisOrder/price/verify') {
//       console.log(JSON.parse(response.data).status);
//       if (JSON.parse(response.data).status == '2031') {
//         message.error(JSON.parse(response.data).msg);
//       }
//     }
//     piniaStore.setSpin(false);
//     if (response.status === 200) {
//       // 成功
//       const returnInfo = response.data;
//       const message = returnInfo.msg || returnInfo.errorCode;
//       // if (message && message.includes && message.includes('available server')) {
//       //   Message.error('重启服务中，请稍后访问')
//       //   console.log('请求失败:-->', returnInfo)
//       // }

//       // if (!response.config.url.includes('index/login')) {
//       //   if (returnInfo.code == 3) {
//       //     Message.error('当前账号登录失效，请重新登录')
//       //     setTimeout(() => {
//       //       Cookies.remove('token')
//       //       Store.commit('logout')
//       //       router.push('/login')
//       //     }, 3000)
//       //   }
//       // }
//     }
//     if (response.data.status == -1) {
//       myStorage.delStore('token');
//       myStorage.delStore('userInfo');
//       piniaStore.setIsLogin(false);
//     }
//     return response.data;
//   },
//   (error) => {
//     /***** 接收到异常响应的处理开始 *****/
//     if (error && error.response) {
//       // 1.公共错误处理
//       // 2.根据响应码具体处理
//       switch (error.response.status) {
//         case 400:
//           error.message = '错误请求';
//           break;
//         case 401:
//           error.message = '未授权，请重新登录';
//           break;
//         case 403:
//           error.message = error.response.data.message;
//           break;
//         case 404:
//           error.message = '请求错误,未找到该资源';
//           break;
//         case 405:
//           error.message = '请求方法未允许';
//           break;
//         case 408:
//           error.message = '请求超时';
//           break;
//         case 500:
//           error.message = '服务器端出错';
//           break;
//         case 501:
//           error.message = '网络未实现';
//           break;
//         case 502:
//           error.message = '连接服务器失败';
//           break;
//         case 503:
//           error.message = '重启服务中，请稍后访问';
//           break;
//         case 504:
//           error.message = '网络超时';
//           break;
//         case 505:
//           error.message = 'http版本不支持该请求';
//           break;
//         default:
//           error.message = `连接错误${error.response.status}`;
//       }
//     }
//     // else {
//     //   // 超时处理
//     //   console.log(error)
//     //   // if (JSON.stringify(error).includes("timeout")) {
//     //   //   ElMessage.error("服务器响应超时，请刷新当前页");
//     //   // }
//     //   ElMessage.error("连接服务器失败");
//     // }
//     // Message.error(error.message)

//     return Promise.reject(error);
//   }
// );

export const useDefaultRequest = {
  get: (url: UrlType, params?: any, option?: RequestOptions) => {
    return request(url, params, { method: 'GET', ...option });
  },
  post: (url: UrlType, params?: any, option?: RequestOptions) => {
    return request(url, params, { method: 'POST', ...option });
  },
};

